import { render, staticRenderFns } from "./RelatedQuestions.vue?vue&type=template&id=02f2e320"
import script from "./RelatedQuestions.vue?vue&type=script&lang=js"
export * from "./RelatedQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports